import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from '../../modal';
import Body from './error-modal-body';

const ErrorModal = ({ errorIsVisible, ...props }) => {
  return (
    <Modal visible={errorIsVisible} onClose={props.popError}>
      <Body {...props} close={props.popError} />
    </Modal>
  );
};
ErrorModal.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      data: PropTypes.shape({
        errors: PropTypes.arrayOf(
          PropTypes.shape({
            message: PropTypes.string,
          }),
        ),
      }),
    }),
  ]),
  errorIsVisible: PropTypes.bool.isRequired,
  popError: PropTypes.func.isRequired,
};

ErrorModal.defaultProps = {
  error: null,
};

export default ErrorModal;
